{
  "title": "Mein Profil",
  "subtitle": "Eigene Konto-Einstellungen",
  "fields": {
    "username": "Benutzername",
    "role": "Rolle"
  },
  "password": {
    "title": "Passwort",
    "description": "Aus Sicherheitsgründen regelmäßig ändern.",
    "button": "Passwort ändern",
    "current_label": "Aktuelles Passwort",
    "new_label": "Neues Passwort",
    "min_length_hint": "Mindestens 8 Zeichen",
    "success": "Passwort gespeichert."
  },
  "language": {
    "title": "Sprache",
    "description": "Sprache der Oberfläche."
  },
  "theme": {
    "title": "Farbschema",
    "description": "Akzentfarbe der Oberfläche. Wirkt sofort, wird im Browser gespeichert."
  },
  "landing": {
    "title": "Startseite",
    "description": "Welche Seite nach dem Login zuerst angezeigt wird.",
    "buddy": "Buddy",
    "dashboard": "Dashboard"
  },
  "backup": {
    "title": "Eigene Daten",
    "description": "Export oder Restore aller eigenen Daten (DSGVO Art. 20).",
    "download": "Daten exportieren",
    "downloading": "Wird erstellt…",
    "restore": "Wiederherstellen",
    "restoring": "Wird wiederhergestellt…",
    "restore_confirm": "Eigene Daten aus diesem Backup wiederherstellen?\n\nBestehende Sessions und Dateien bleiben erhalten — neue Daten werden ergänzt.",
    "restore_done": "Wiederhergestellt.",
    "error": "Fehler: {{msg}}"
  }
}
